import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { EventMessage, EventType, InteractionType, InteractionStatus, PopupRequest, RedirectRequest, AuthenticationResult, AuthError } from '@azure/msal-browser';
import { b2cPolicies } from './auth-config-b2c';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpParams } from '@angular/common/http';
import { RequestData } from './shared/Model/RequestData';
import { Parent_Permision } from './shared/sidebar/model';
import { DataServicesService } from './Services/data-services.service';
import { triggerAsyncId } from 'async_hooks';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { ProfileType } from './shared/Model/ProfileType';
import { Common } from './shared/global/common';

const GRAPH_ENDPOINT = 'https://graph.microsoft.com/v1.0/me';

// type ProfileType = {
//   givenName?: string,
//   surname?: string,
//   userPrincipalName?: string,
//   id?: string
// }

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Microsoft identity platform';
  isIframe = false;
  loginDisplay = false;
  profile!: ProfileType;
  dataSource: any = [];
  private readonly _destroying$ = new Subject<void>();


  constructor(@Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration, private broadcastService: MsalBroadcastService, private authService: MsalService) { }

  ngOnInit() {

    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.setLoginDisplay();
    })
  }

  login() {
    if (this.msalGuardConfig.authRequest){
      this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
    } else {
      this.authService.loginRedirect();
    }
  }

  logout() { 
    this.authService.logoutRedirect({
      postLogoutRedirectUri: '/'
    });
  }

  setLoginDisplay() {    
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    if(!this.loginDisplay){
      this.login();
    }
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
  /* Changes end here. */
}
